import { defineStore } from 'pinia'

// State of the session expiry dialog, managed by SessionTimeoutManager (see services/session)
export const useSessionStore = defineStore('session', {
  state: () => {
    return {
      isWarningModalVisible: false,
      secondsRemaining: 0
    }
  },
  actions: {
    showWarning() {
      this.isWarningModalVisible = true;
    },
    hideWarning() {
      this.isWarningModalVisible = false;
    },
    updateSeconds(seconds) {
      this.secondsRemaining = Math.max(seconds, 0);
    }
  }
});
